import React from 'react';
import PropTypes from 'prop-types';
import PanelsDisplayTable from 'app-ui-componentlibrary/dist/componentLibrary/layout/PanelsDisplayTable';
import {Header, Segment} from 'semantic-ui-react';
import {connectWithCore} from 'framework/hocs';
import {Item, Loader} from 'semantic-ui-react';
import {getPartName} from 'common/utils';
import _ from 'lodash';

const parseScoresByPartFactor = (scores) => {
  const factorsByPart = {};

  _.forEach(scores, (score) => {
    const partFactorScores = _.get(factorsByPart, [score.partId, score.factor], []);
    _.set(factorsByPart, [score.partId, score.factor], [...partFactorScores, score]);
  });

  return factorsByPart;
};

export const PanelReviewScoreSummary = ({
  id,
  refItems,
  fundingStreams,

  // entity overall score by session
  sessionScores,
  sessionSummaryLabel,
  sessionsData,

  // part overall score section
  partSummaryScores,
  partLabel,
  partScoreLabel,

  // part-factor score breakdown section
  partFactorScores,
  reviewerLabel,
  factorScoreLabel,
  factorJustificationLabel,
}) => {
  const summaryTable = {
    columnHeaders: [partLabel, partScoreLabel],
    columnKeys: ['partName', 'score'],
    columnWidths: [10, 6],
  };

  const partFactorBreakdownTable = {
    columnHeaders: [reviewerLabel, factorScoreLabel, factorJustificationLabel],
    columnKeys: ['emailAdr', 'text', 'justification'],
    columnWidths: [3, 2, 6],
  };

  if (!refItems) {
    return (
      <Loader active inline="centered">
        Loading...
      </Loader>
    );
  } else {
    return (
      <React.Fragment>
        {_.map(sessionScores, (session) => {
          const partFactorScoresForSession = _.filter(
            partFactorScores,
            (score) => score.sessionId == session.sessionId
          );
          const partSummaryScoresForSession = _.filter(
            partSummaryScores,
            (score) => score.sessionId == session.sessionId
          );

          const sessionName = sessionsData
            ? _.result(
                _.find(sessionsData, (s) => s.sessionId === session.sessionId),
                'sessionName',
                sessionSummaryLabel
              )
            : sessionSummaryLabel;

          let rows = _.map(partSummaryScoresForSession, (p) => {
            // Find and add partName to each row
            let partName = getPartName(p.part, refItems, p.partId, fundingStreams);
            const pWithRoundedScore = {...p, score: _.round(p.score, 2).toFixed(2)};
            return {...pWithRoundedScore, partName};
          });
          const parsedScores = parseScoresByPartFactor(partFactorScoresForSession);
          return (
            <React.Fragment key={session.sessionId}>
              <Header as="h2" id={id || ''}>
                {sessionName}
              </Header>
              <Segment>
                <Item.Group>
                  <Item>
                    <Item.Content className={`half-width name-value__text-align-left`}>
                      Session score
                    </Item.Content>
                    <Item.Content className={`half-width name-value__text-align-left`}>
                      {/**This is where the Session score rendered, taking the highest score from the rows array. Ignoring the value in the db. Related table panelreview2.session_entity_score **/}
                      <strong>
                        {_.round(
                          Math.max.apply(
                            null,
                            rows.map(function (o) {
                              return o.score;
                            })
                          ),
                          2
                        ).toFixed(2)}
                      </strong>
                    </Item.Content>
                  </Item>
                </Item.Group>
                <PanelsDisplayTable
                  summary={`${partLabel} scores`}
                  columnHeaders={summaryTable.columnHeaders}
                  columnKeys={summaryTable.columnKeys}
                  columnWidths={summaryTable.columnWidths}
                  rows={rows}
                />
                {_.map(parsedScores, (factors, partId) => {
                  const part = _.get(
                    _.find(partSummaryScores, (partScore) => partScore.partId == partId),
                    'part'
                  );
                  const partName = getPartName(part, refItems, partId, fundingStreams);
                  return (
                    <React.Fragment key={partId}>
                      <Header as="h3">{partName}</Header>
                      {_.map(factors, (scores, factor) => (
                        <React.Fragment key={partId + '-' + factor}>
                          <Header as="h4">{factor}</Header>
                          <PanelsDisplayTable
                            summary={`${partName} ${factor} scores`}
                            columnHeaders={partFactorBreakdownTable.columnHeaders}
                            columnKeys={partFactorBreakdownTable.columnKeys}
                            columnWidths={partFactorBreakdownTable.columnWidths}
                            rows={scores}
                          />
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  );
                })}
              </Segment>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
};

PanelReviewScoreSummary.propTypes = {
  sessionSummaryLabel: PropTypes.string.isRequired,
  sessionsData: PropTypes.arrayOf(PropTypes.object).isRequired,
  partLabel: PropTypes.string.isRequired,
  partScoreLabel: PropTypes.string.isRequired,
  reviewerLabel: PropTypes.string.isRequired,
  factorScoreLabel: PropTypes.string.isRequired,
  factorJustificationLabel: PropTypes.string.isRequired,
};

export default connectWithCore(PanelReviewScoreSummary);
